export class CustomerRoiTool {
    ID: number;
    CRTNumber: string;
    PrimaryGroup?: string;
}

export default CustomerRoiTool;